module.exports = __webpack_public_path__ + "img/index_pic1.ffd66e60.png";